import {Injectable} from '@angular/core';
import {AuthService} from 'projects/firebase/src/lib/services/auth.service';
import {Router} from '@angular/router';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {Observable} from 'rxjs';
import {AuthComponent} from 'projects//paid_ukr/src/app/components/auth/auth.component';
import {DataService} from 'projects/firebase/src/lib/services/data.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService {
  constructor(
    public auth: AuthService,
    public data: DataService,
    public router: Router,
    private modalService: NgbModal,
  ) {
  }

  canActivate(): Observable<boolean> | Promise<boolean> | boolean {
    return this.auth.isLoggedIn || this.openAuthModal();
  }

  openAuthModal(): Promise<any> {
    const modalRef = this.modalService.open(AuthComponent, {
      centered: true,
      size: 'md',
      windowClass: 'modal login',
      backdrop: 'static',
      keyboard: true
    });
    modalRef.componentInstance.data = {};
    return modalRef.result;
  }

}
